import { Link } from "react-router-dom";

import { Button } from "common/components/ui/Button";
import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import usePromotions from "common/datahooks/usePromotions";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import AgencySubscriptionCard from "../AgencySubscriptionCard";
import { LinkedInCrm, Rented } from "./SubscriptionCards";

export default function Overview() {
  const isDesktop = useTwBreakpoint("lg");
  const { role } = useSelectedWorkspaceContext();
  const { agencyPlan, appSumoPromotion, ltdPromotion } = usePromotions();

  return (
    <>
      {role === "owner" && (appSumoPromotion || ltdPromotion) && (
        <Button size={isDesktop ? "sm" : "md"} className="ml-auto">
          <Link to="../ltd">Lifetime seats</Link>
        </Button>
      )}
      {agencyPlan ? (
        <AgencySubscriptionCard isAgencyPage={false} />
      ) : (
        <LinkedInCrm />
      )}
      <Rented />
    </>
  );
}
